import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=1789c0f2&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=1789c0f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789c0f2",
  null
  
)

export default component.exports